import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const speedLearnTopicBySubjectIdAsync = createAsyncThunk(
  "web/speedLearnTopicBySubjectId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/speedLearnTopicBySubjectId?subjectId=${payload.subjectId}`,
      [],
      toolkit
    );
  }
);

export const speedLearnByTopicIdAsync = createAsyncThunk(
  "web/speedLearnByTopicId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/speedLearnByTopicId?topicId=${payload.topicId}`,
      [],
      toolkit
    );
  }
);
